import requestConfig from '../../../shared/config/request';
import { get, put } from '../../../infra/rest';
import { ACTION_TYPES, cxOverview } from '../typings';

export const getCxOverview = async ({
  searchTerm,
  lastDateCreated,
  pageSize,
}: {
  searchTerm: string | null;
  lastDateCreated: string | null;
  pageSize: number | null;
}): Promise<{ data: cxOverview[]; hasMore: boolean; nextLastDateCreated: string }> => {
  return await get<{ data: cxOverview[]; hasMore: boolean; nextLastDateCreated: string }>(
    `${requestConfig.aiBotBaseUrl}/v1/ai/analytics/customer-cx-issues?${searchTerm ? `searchTerm=${searchTerm}&` : ''}${
      lastDateCreated ? `lastDateCreated=${lastDateCreated}&` : ''
    }${pageSize ? `pageSize=${pageSize}` : ''}`,
    {},
    true,
    false,
    true
  );
};

export const updateCxIssueState = async ({ id, state }: { id: string; state: ACTION_TYPES }): Promise<void> => {
  return await put<void>(
    `${requestConfig.aiBotBaseUrl}/v1/ai/analytics/customer-cx-issues/${id}`,
    {
      body: JSON.stringify({ state }),
    },
    true,
    false,
    true
  );
};

export const getIsCxIssueEnabled = async () => {
  return await get<{ enabled: boolean }>(
    `${requestConfig.aiBotBaseUrl}/v1/ai/analytics/customer-cx-issue-enabled`,
    {},
    true,
    false,
    true
  );
};
